import React from "react";
import HStack from "./HStack";

type Props = {
  title: string;
  description?: string;
  className?: string;
  menu?: React.ReactNode;
};

const TitlePage = ({ title, description, className, menu }: Props) => {
  return (
    <div className={`${className}`}>
      <HStack gap={2}>
        <p className="text-[21px] font-semibold">{title}</p>
        {menu ? menu : null}
      </HStack>
      {description ? <p className="text-sm text-mediumGray dark:text-midGray">{description}</p> : null}
    </div>
  );
};

export default TitlePage;
